<template>
  <div id="container" class="gnb_pdt">
    <div class="title_wrap"><h1>발주목록</h1></div>
    <common-area-search
        :row="3"
        :colspan="2"
        @search="commonOnChangeEvent"
        @clear="cleanSearchDataEvent"
    >
      <template v-slot:R2_C1>
        <label>품목명</label>
        <ul>
          <common-multi-drop-down
              ref="itemCdRef"
              :params="{ searchCmpyCd : propsCmpyCd }"
              :url="`${ApiConfig.efsDomain}/efs/drop-down/item`"
              :data-value-field="'itemCd'"
              :data-text-field="'itemNm'"
              @change="value=>{
                vm.propsItemCd = value
                vm.commonOnChangeEvent()
              }"
          >
          </common-multi-drop-down>
        </ul>
      </template>
      <template v-slot:R2_C2>
        <label>상품명</label>
        <ul>
          <common-multi-drop-down
              ref="goodsCdRef"
              :params="{ searchItemCd : propsItemCd }"
              :url="`${ApiConfig.efsDomain}/efs/drop-down/goods`"
              :data-value-field="'goodsCd'"
              :data-text-field="'goodsNm'"
              @change="commonOnChangeEvent"
          >
          </common-multi-drop-down>
        </ul>
      </template>
      <template v-slot:R3_C1>
        <label>공급업체명</label>
        <ul>
          <common-multi-drop-down
              ref="supCmpyCdRef"
              :params="{ searchCmpyGbn : '05', searchAllYn : 'Y' }"
              :data-columns="[{ field: 'cmpyNm', title: '회사명', width: '60%' },{ field: 'cmpyCd', title: '회사코드', width: '40%' }]"
              :url="`${ApiConfig.efsDomain}/efs/drop-down/company`"
              :data-value-field="'cmpyCd'"
              :data-text-field="'cmpyNm'"
              @change="commonOnChangeEvent"
          >
          </common-multi-drop-down>
        </ul>
      </template>
      <template v-slot:R1_C2>
        <label>발주기간</label>
        <ul>
          <common-range-datepicker
              ref="dtRef"
              @change="commonOnChangeEvent"
          >
          </common-range-datepicker>
        </ul>
      </template>
      <template v-slot:R1_C1>
        <label>통합검색</label>
        <ul>
          <input
              ref="compoundTextRef"
              class="k-textbox w100"
              placeholder="회사명, 공급업체 담당자로 검색"
              @keyup.enter="commonOnChangeEvent"
          />
        </ul>
      </template>
      <template v-slot:R3_C2>
        <label>정산여부</label>
        <ul>
          <common-button-group
              ref="adjtYnRef"
              :style="'width: 100%; border: 0;'"
              :data-items="[{text: '전체', value:''},{text: '필요', value:'Y'},{text: '불필요', value:'N'}]"
              @click="commonOnChangeEvent"
          >
          </common-button-group>
        </ul>
      </template>
    </common-area-search>

    <section>
      <div class="contents_top_sec">
        <div class="c_t_button_wrap fl">
          <button @click="$router.push({ name: 'OrdManageNew' })" class="mid_btn orange">발주등록</button>
        </div>
        <div class="c_t_button_wrap fr">
          <button @click="$router.push({ name: 'OrdManageCalendar' })" class="mid_btn green">캘린더로보기</button>
        </div>
        <div class="c_t_button_wrap fr mr5">
          <button class="mid_btn" @click="onClickExcelDownload"><i class="download_icon"></i>엑셀 다운로드</button>
        </div>
      </div>

      <div class="content_list">
        <kendo-grid ref="gridRef"
                    style="cursor: pointer"
                    :data-source="computedOrdGridRows"
                    :navigatable="false"
                    :sortable-mode="'multiple'"
                    :pageable-page-sizes="[5, 10, 20, 50, 100, 500, 1000]"
                    :reorderable="true"
                    :column-menu="false"
                    :resizable="true"
                    :selectable="'row'"
                    :columns="gridColumns"
                    :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }"
                    @change="onChangeGrid"
        />
        <!-- Kendo 영역 끝 -->
      </div>
    </section>

  </div>
</template>

<script>
import ApiConfig from '@/api/api.config'
import EtnersDateTimeUtil from '@ebmp-fe-common-module/module/src/common/etners.datetime.util.js'
import ApiUtil from '@/api/api.util'
import EtnersCommonUtil from '@ebmp-fe-common-module/module/src/common/etners.common.util'
import { saveExcel } from '@progress/kendo-vue-excel-export'
import EtnersEfsUtil from '@/common/etners.efs.util'
import Constant from '@/common/constant'

export default {
  name: 'OrdManageList',
  computed: {

    computedOrdGridRows: function () {
      const vm = this

      const gridDataSource = new kendo.data.DataSource({
        name: 'gridDataSource',
        page: 1,
        pageSize: 10,
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        transport: {
          read: {
            url: `${ApiConfig.efsDomain}/efs/manage/ord`,
            type: 'GET',
            contentType: 'application/json',
            cache: false,
          },
          parameterMap: function (options, operation) {

            if (operation === 'read') {

              let filters = vm.searchFilterParam()
              let sort = EtnersEfsUtil.convertJSONArrayToJSON('sort', options.sort)

              vm.lastRouteParams = {
                loginUserToken: vm.$store.state.loginStore.lutk,
                skip: options.skip,
                take: options.take,
                page: options.page,
                pageSize: options.pageSize,
                ...sort,
                ...filters
              }
              return vm.lastRouteParams
            }

            if (operation !== 'read' && options.models) {
              return { models: kendo.stringify(options.models) }
            }
          },
        },
        schema: {
          type: 'json',
          parse: function (response) {
            let changeResultData = response.resultData
            let rowNumber = (vm.$refs.gridRef.dataSource.page() - 1)
                * vm.$refs.gridRef.dataSource.pageSize()
            for (let i = 0; i < changeResultData?.length; i++) {
              let row = changeResultData[i]
              // row 번호 셋팅
              row.rowNumber = response.total - rowNumber++
              row.searchName = vm.$refs.compoundTextRef.value
            }
            response.resultData = changeResultData
            return response
          },
          total: function (response) {
            return response.total
          },
          data: function (response) {
            if (response.resultStatus.messageCode === '2000') {
              return response.resultData
            }else if(response.resultStatus.messageCode === '4154'){
              vm.$store.dispatch('LOGOUT').then(() => {
                kendo.alert(response.resultStatus.messageText).bind('close', function() {
                  window.location.href = `/login`
                })
              })
            }else {
              kendo.alert( response.resultStatus.messageText)
              return ''
            }
          },
        },

        error: function (e) {
          console.log('error event handler', e.errors[0])
        },
      })
      return gridDataSource
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(['OrdManageDetail','OrdManageEdit'].includes(from.name)){
        vm.$refs.gridRef.kendoWidget()?.dataSource.read()
      }
    })
  },
  methods : {
    cleanSearchDataEvent: function (ev) {
      const refs = this.$refs

      /**
       * 통합검색, 발주기간, 품목명, 상품명, 공급업체명, 공급업체담당자
       * */
      refs.compoundTextRef.value = ''
      refs.dtRef?.widget().init()
      refs.itemCdRef.widget().value('')
      refs.goodsCdRef.widget().value('')
      refs.supCmpyCdRef.widget().value('')
      refs.adjtYnRef.widget().value('')
      this.propsCmpyCd = ''
      this.propsItemCd = ''
      this.commonOnChangeEvent()

    },
    searchFilterParam: function () {
      let searchFilterOptions = {}
      const refs = this.$refs


      // 통합검색
      const compoundText = refs.compoundTextRef.value
      if (!!compoundText) {searchFilterOptions.searchCompoundText = compoundText}

      //품목명
      const itemCd = refs.itemCdRef.widget().value()
      if (itemCd) {searchFilterOptions.searchItemCd = itemCd}

      //상품명
      const goodsCd = refs.goodsCdRef.widget().value()
      if (goodsCd) {searchFilterOptions.searchGoodsCd = goodsCd}

      //공급사
      const supCmpyCd = refs.supCmpyCdRef.widget().value()
      if (supCmpyCd) {searchFilterOptions.searchSupCmpyCd = supCmpyCd}

      // 발주일자
      const dtRefValue = refs.dtRef.widget().range()
      if (dtRefValue) {
        const searchStartDt = dtRefValue.start
            ? EtnersDateTimeUtil.dateToYYYYMMDD(dtRefValue.start) : ''
        const searchEndDt = dtRefValue.end
            ? EtnersDateTimeUtil.dateToYYYYMMDD(dtRefValue.end) : ''
        searchFilterOptions.searchStartOrdDt = searchStartDt
        searchFilterOptions.searchEndOrdDt = searchEndDt
      }

      //정산여부
      const adjtYn = refs.adjtYnRef.widget().value()
      if (adjtYn) {searchFilterOptions.searchAdjtYn = adjtYn}

      return searchFilterOptions ?? undefined
    },
    commonOnChangeEvent: function () {
      const gridRef = this.$refs.gridRef
      gridRef?.kendoWidget()?.dataSource?.query({
        sort: {},
        take: 10,
        page:  1,
        pageSize:  10,
      })
    },
    onChangeGrid (ev) {
      let cellIdx = window.event.target.cellIndex
      let boolForg = window.event.target.className === 'forg' // 키워드 강조 span태그 클릭시에도 deatil로 이동
      if (!isNaN(cellIdx) || boolForg) {
        let selectedRow = ev.sender.select()
        let rowData = ev.sender.dataItem(selectedRow)
        this.$router.push(
            { name: 'OrdManageDetail',
              params: { ordNo : rowData.ordNo }
            })
      }
    },
    onClickExcelDownload: function(e) {

      const vm = this
      vm.lastRouteParams.requestType = 'EXPORT'
      ApiUtil.query(`${ApiConfig.efsDomain}/efs/manage/sect`, vm.lastRouteParams).then(response => {

        if (response.data.resultStatus.messageCode === '2000') {
          let resultData = response.data.resultData
          if(EtnersCommonUtil.isNotEmpty(resultData) && resultData.length > 0) {

            let gridColumns = vm.gridColumns.reduce((acc, cur) => {
              if(cur.field !== 'rowNumber'){ acc.push({ ...cur, width : '120px' }) }
              return acc;
            }, []);

            saveExcel({
              data: resultData,
              fileName: '발주목록_' + EtnersDateTimeUtil.dateToYYYYMMDD(new Date()) + '.xlsx',
              columns: gridColumns
            })
          } else {
            kendo.alert('다운로드 할 자료가 없습니다.')
          }
        } else {
          kendo.alert( response.data.resultStatus.messageText)
          return false
        }
      })
    },
  },
  data () {
    const headerAttributes = { style: 'font-weight: bold; text-align: center;' }
    const centerAttributes = { style: 'text-align: center;' }
    const rightAttributes = { style: 'text-align: right;' }
    const vm = this
    return {
      vm: vm,
      Constant,
      ApiConfig : ApiConfig,
      lastRouteParams : {},
      isWindowOpen : false,
      propsCmpyCd : '',
      propsItemCd : '',
      gridColumns: [
        {
          field: 'rowNumber',
          title: 'No',
          width: '3%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes,
          sortable: false
        },
        {
          field: 'cmpyNm',
          title: '회사명',
          width: '10%',
          headerAttributes: headerAttributes,
        },
        {
          field: 'itemNm',
          title: '품목',
          width: '%',
          headerAttributes: headerAttributes,
        },
        {
          field: 'goodsNm',
          title: '상품명',
          width: '15%',
          headerAttributes: headerAttributes,
        },
        {
          field: 'supCnt',
          title: '수량',
          width: '6%',
          headerAttributes: headerAttributes,
          attributes: rightAttributes,
          template: function (dataItem) {
            return EtnersCommonUtil.numberWithCommas(dataItem.supCnt)
          }
        },
        {
          field: 'supCmpyNm',
          title: '공급업체명',
          width: '9%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes
        },
        {
          field: 'supMngUnqUserNm',
          title: '공급업체 담당자',
          width: '6%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes,
          template: function (dataItem) {
            return EtnersEfsUtil.emphasisGridSearchText(dataItem.searchName, dataItem.supMngUnqUserNm)
          }
        },
        {
          field: 'sendDt',
          title: '발주서 발송일',
          width: '10%',
          headerAttributes: headerAttributes,
          attributes : centerAttributes
        },
        {
          field: 'inExpectDate',
          title: '입고예정일',
          width: '7%',
          headerAttributes: headerAttributes,
          attributes : centerAttributes
        },
        {
          field: 'frstRgstNm',
          title: '발주등록자',
          width: '6%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes
        },
        {
          field: 'inStatusNm',
          title: '입고여부',
          width: '4%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes
        },
        {
          field: 'adjtYn',
          title: '정산필요',
          width: '3%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes
        },
        {
          field: 'frstRgstDt',
          title: '등록일자',
          width: '8%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes
        },
      ],
    }
  },
}
</script>

<style scoped>

</style>
